import React, { useState, useEffect } from 'react';
import { Box, Checkbox, FormControlLabel, Grid, Link, List, ListItem, Paper, Tab, Tabs, Typography } from '@mui/material';
import LoadingOverlay from 'react-loading-overlay-nextgen';
import { useDispatch, useSelector } from 'react-redux';

import Alerts from '../alerts';
import SearchForm from '../search-form/search-form';
import StacItemCard from './stac-item-card';
import { setTab, toggleExtentVisibility } from '../viewer/viewer-slice';

function CustomTabPanel(props) {
    // eslint-disable-next-line react/prop-types
    const { children, value, index, ...other } = props;


    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function SearchPanel() {

    const dispatch = useDispatch()
    const configuration = useSelector((state) => state.configuration.value)
    const active = useSelector((state) => state.viewer.active)
    const messages = useSelector((state) => state.viewer.messages)
    const collection = useSelector((state) => state.viewer.collection)
    const visible = useSelector((state) => state.viewer.visible)
    const tab = useSelector((state) => state.viewer.tab)

    const [properties, setProperties] = useState(null);

    useEffect(() => {
        fetch(`${configuration.url}/api/stac-property/get-all`, {
            method: 'GET',
        }).then((response) => {
            if (response.ok) {
                response.json().then(props => {
                    setProperties(props);
                });
            }
        });
    }, [configuration]);

    const setTabState = (t) => {
        dispatch(setTab(t));
    }

    return (
        <Paper style={{ maxHeight: '100vh', overflow: 'auto' }}>
            <LoadingOverlay
                active={active}
                spinner
                text='Communicating with server...'
            >
                <Alerts messages={messages} />
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tab} onChange={(e, t) => { setTabState(t) }} aria-label="basic tabs example">
                        <Tab label="Search" {...a11yProps(0)} />
                        <Tab label="Results" {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={tab} index={0}>
                    {properties != null && (
                        <SearchForm properties={properties} />
                    )}
                </CustomTabPanel>
                <CustomTabPanel value={tab} index={1}>
                    {collection != null && collection.links.length > 1 && (
                        <Box>


                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={<Checkbox checked={visible} />}
                                        label="Show collection extent on map"
                                        name="collectionExtent"
                                        onChange={() => { dispatch(toggleExtentVisibility()) }}
                                    />
                                </Grid>
                                {collection.links.filter(link => link.rel === 'self').map((row) => (
                                    <Grid item xs={12}>
                                        <Link href={row.href} color="primary" target='_blank'>
                                            Share STAC collection
                                        </Link>
                                    </Grid>
                                ))}
                                <Grid item xs={12}>
                                    <Typography variant="h5" component="h5">Spatial Extent</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            {collection.extent.spatial.bbox[0][0]}
                                        </Grid>
                                        <Grid item xs={6}>
                                            {collection.extent.spatial.bbox[0][1]}
                                        </Grid>
                                        <Grid item xs={6}>
                                            {collection.extent.spatial.bbox[1][0]}
                                        </Grid>
                                        <Grid item xs={6}>
                                            {collection.extent.spatial.bbox[1][1]}
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="h5" component="h5">Temporal Extent</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={2}>
                                            <Typography>Start</Typography>
                                        </Grid>
                                        <Grid item xs={10}>
                                            {collection.extent.temporal.interval[0]}
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Typography>End</Typography>
                                        </Grid>
                                        <Grid item xs={10}>
                                            {collection.extent.temporal.interval[1]}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Typography variant="h5" component="h5" mt={3}>Items</Typography>
                            <List>
                                {collection.links.filter(link => link.rel === 'item').map((row) => (
                                    <ListItem key={row.href}>
                                        <StacItemCard key={row.href} properties={properties} collection={collection} link={row} />
                                    </ListItem>
                                ))}

                            </List>
                        </Box>

                    )}
                    {collection != null && collection.links.length === 1 && (
                        <Box>
                            <Typography variant="h3" component="h3">No Items found</Typography>
                        </Box>
                    )}

                </CustomTabPanel>
            </LoadingOverlay>

        </Paper>


    );
}
